import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useEffect, useState } from 'react';
import { numberToCurrencyFormatter } from '../core-utils/helper-utils/helper';
import {
  CardComponent,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { scrollBarStyles } from '../core-utils/messages/CommonConstants';

const cellStyles1 = {
  color: `${patientAccessTheme.palette.text.highemphasis} !important`,
  padding: '10px 14px !important',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[300],
};

const headerStyles1 = {
  color: `${patientAccessTheme.palette.status.white} !important`,
  padding: '10px 14px !important',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '19px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[700],
};

export interface TopServicesMedicalSpendProps {
  incurredStartDate?: string;
  incurredEndDate?: string;
  paidStartDate?: string;
  paidEndDate?: string;
  aggregationParameter?: string;
  type: 'service' | 'medpharma';
  data: any;
}

const TopServicesMedicalSpend: React.FC<TopServicesMedicalSpendProps> = ({
  data,
  type,
}) => {
  const [topMedpharmaDrugs, setTopMedpharmaDrugs] = useState<any[]>([]);

  const columns = [
    {
      name: type === 'service' ? 'SERVICE TYPE' : 'MEDICATION',
      align: 'left',
    },
    {
      name: 'OCCURENCES',
      align: 'left',
    },
    {
      name: 'PLAN PAID',
      align: 'right',
    },
    {
      name: 'TOTAL PAID',
      align: 'right',
    },
  ];

  //functions
  const formatTableData = (data: any) => {
    const tableData: any[][] = [];
    data?.forEach((item: any) => {
      const eachRowData = [];
      eachRowData[0] =
        type === 'service' ? item?.serviceType : item?.medication;
      eachRowData[1] = item?.occurences;
      eachRowData[2] = numberToCurrencyFormatter(item?.planPaid, true, 0);
      eachRowData[3] = numberToCurrencyFormatter(item?.totalPaid, true, 0);
      tableData?.push(eachRowData);
    });

    return tableData;
  };

  //useEffects
  useEffect(() => {
    setTopMedpharmaDrugs(formatTableData(data?.topDrugs));
  }, []);

  return (
    <CardComponent
      title={`Top 10 ${
        type === 'service' ? 'Services' : 'Medpharma Drugs'
      } in Medical Plan Spend`}
      mainGridStyles={{
        overflow: 'scroll',
        ...scrollBarStyles,
      }}
      height="100%"
      padding="16px"
      body={
        topMedpharmaDrugs?.length > 0 ? (
          <PptReportTable
            data={topMedpharmaDrugs}
            columns={columns}
            cellStyles={cellStyles1}
            headerStyles={headerStyles1}
            tableStyles={{
              marginTop: '16px !important',
            }}
          />
        ) : (
          <NoDataVisual content="No Data Available" />
        )
      }
    />
  );
};

export default TopServicesMedicalSpend;
